<template>
	<div class="basis-page-cls sms-container">
		<section class="basis-cls_filter">
			<table-search :filterHeader="filterHeader" :defaultQuery="listQuery" @filterSearch="filterSearch" @onSwitch="onSwitch" />
		</section>
		<div class="basis-cls_table">
			<div class="header">
				<span class="title el-icon-document"> 数据列表</span>
				<div class="btns">
					<el-button @click.stop="handleSend('single')" v-if="listQuery.type == 'single'" type="primary" size="small" icon="el-icon-circle-plus-outline" class="right">短信单发</el-button>
					<el-button @click.stop="handleSend('group')" v-else type="primary" size="small" icon="el-icon-circle-plus-outline" class="right">短信群发</el-button>
				</div>
			</div>
			<el-container class="box">
				<div class="box__main">
					<div class="resize-bar"></div>
					<div class="resize-line"></div>
					<div class="resize-save">
						<Left :sendCount="sendCount" :listQuery="listQuery" @onEmitItemData="onEmitItemData" />
					</div>
				</div>
				<div class="box__user">
					<Right :listQuery="listQuery" :itemData="itemData" @onEmitList="onEmitList" />
				</div>
			</el-container>
		</div>

		<el-drawer 
			title="短信单发"
            :visible.sync="dialogFormVisible"
            :wrapperClosable="false"
			:modal-append-to-body="false"
			size="800px"
            direction="rtl">
           <TouchIn v-if="dialogFormVisible" :listQuery="listQuery" @closeDialogFormVisible="handleCloseDialogFormVisible" />
        </el-drawer>

		<el-drawer 
			title="短信群发"
            :visible.sync="dialogFormVisibleGroup"
            :wrapperClosable="false"
			:modal-append-to-body="false"
			size="800px"
            direction="rtl">
		   <TouchInGroup v-if="dialogFormVisibleGroup" :listQuery="listQuery" @closeDialogFormVisible="handleCloseDialogFormVisible" />
        </el-drawer>
	</div>
</template>
<script>
import Left from './components/Left';
import Right from './components/Right';
import TouchIn from './components/TouchIn';
import TouchInGroup from './components/TouchInGroup';
export default {
	components: {Left, Right, TouchIn, TouchInGroup},
	data() {
		return {
			filterHeader: [
				{ label: '发送类型',model: 'type', type: 'tabs' ,default: 'single', list: [{name: '单发', id: 'single'}, {name: '群发', id: 'group'}]}, 
				{ label: '账号查询', model: 'configId', type: 'select', default: '', list:[]},
				{ label: '手机号码', model: 'mobileNum', type: 'input', default: '', placeholder: '请输入手机号码' },
				{ label: '发送状态', model: 'sendStatus', type: 'select', default: '', list:[
					{id: 'ready', name: '预约中'},
					{id: 'sent', name: '已发送'},
					{id: 'failed', name: '已失败'},
					{id: 'cancel', name: '已取消'}
				]},
				{ label: '创建人', model: 'accountName', type: 'input', default: '', placeholder: '请输入创建人'},
				{ label: '预约时间', model: 'date3', type: 'datetimerange', default: '', notDisabled: true, placeholder: '请选择'},
				{ label: '创建时间', model: 'date1', type: 'datetimerange', default: '', placeholder: '请选择'},
				{ label: '发送时间', model: 'date2', type: 'datetimerange', default: '', placeholder: '请选择'},
				
			],
			listQuery: {
				pageNum: 1,
				pageSize: 10,
				type: 'single',
				configId: '',
				mobileNum: '',
				sendStatus: '',
				accountName: '',
				date1: [],
				date2: [],
				date3: [],
				createStartTime: '',
				createEndTime: '',
				sendStartTime: '',
				sendEndTime: '',
				scheduleStartTime: '',
				scheduleEndTime: '',
			},
			itemData: {
				customerName: '',
				mobileNum: '',
				sendStatus: '',
				createTime: '',
				accountName: '',
				smsBody: '',
			},
			sendCount: 0,
			dialogFormVisible: false,
			dialogFormVisibleGroup: false
		}
	},
	watch: {
		'listQuery.type': {
			handler(val) {
				console.log(val)
				if(val === 'group') {
					this.filterHeader = [
						{ label: '发送类型',model: 'type', type: 'tabs' ,default: 'single', list: [{name: '单发', id: 'single'}, {name: '群发', id: 'group'}]}, 
						{ label: '账号查询', model: 'configId', type: 'select', default: '', list:[]},
						{ label: '创建人', model: 'accountName', type: 'input', default: '', placeholder: '请输入创建人'},
						{ label: '预约时间', model: 'date3', type: 'datetimerange', default: '', notDisabled: true, placeholder: '请选择'},
						{ label: '创建时间', model: 'date1', type: 'datetimerange', default: '', placeholder: '请选择'},
						{ label: '发送时间', model: 'date2', type: 'datetimerange', default: '', placeholder: '请选择'},
					]
				} else {
					this.filterHeader = [
						{ label: '发送类型',model: 'type', type: 'tabs' ,default: 'single', list: [{name: '单发', id: 'single'}, {name: '群发', id: 'group'}]}, 
						{ label: '账号查询', model: 'configId', type: 'select', default: '', list:[]},
						{ label: '手机号码', model: 'mobileNum', type: 'input', default: '', placeholder: '请输入手机号码' },
						{ label: '发送状态', model: 'sendStatus', type: 'select', default: '', list:[
							{id: 'ready', name: '预约中'},
							{id: 'sent', name: '已发送'},
							{id: 'failed', name: '已失败'},
							{id: 'cancel', name: '已取消'}
						]},
						{ label: '创建人', model: 'accountName', type: 'input', default: '', placeholder: '请输入创建人'},
						{ label: '预约时间', model: 'date3', type: 'datetimerange', default: '', notDisabled: true, placeholder: '请选择'},
						{ label: '创建时间', model: 'date1', type: 'datetimerange', default: '', placeholder: '请选择'},
						{ label: '发送时间', model: 'date2', type: 'datetimerange', default: '', placeholder: '请选择'},
					]
				}
			}
		}
	},
	created() {
		this.getAccountData();
	},
	methods: {
		handleSend(type) {
			if(type == 'group') {
				this.dialogFormVisibleGroup = true;
			} else {
				this.dialogFormVisible = true;
			}
		},
		onEmitItemData(data) {
			console.log(data)
			this.itemData = Object.assign({}, data);
		},
		filterSearch() {
			this.listQuery.pageNum = 1;
			this.sendCount++;
		},
		onSwitch(val) {
			this.listQuery.pageNum = 1;
			this.getAccountData();
			this.listQuery[val.key] = val.data.id;
			this.sendCount++;
			
		},
		handleCloseDialogFormVisible(row) {
			this.dialogFormVisible = false;
			this.dialogFormVisibleGroup = false;
			if(row) this.sendCount++;
		},
		onEmitList() {
			this.sendCount++;
		},
		getAccountData() {
			this.filterHeader[1]['list'] = [];
			this.$api.apiPostSmsConfigList().then(response => {
				if(response.errcode != 0) return;
				for(const item of response.data['configList']) {
					this.filterHeader[1]['list'].push({
						id: item.configId,
						name: item.configName
					});
				}
			});
		},
	}
}
</script>
<style lang="scss" scoped>
.basis-page-cls > .basis-cls_table > div.header {
	margin-bottom: 0;
}
	.sms-container {
		.basis-cls_table {
			height: calc(100% - 70px);
		}

		.box {
			height: calc(100% - 40px);
			border-radius: 4px;
			overflow: hidden;
			width: 100%;

			&__user {
				background-color: #fff;
				height: 100%;
				padding: 0;
				margin: 0;
				overflow: hidden;
				flex: 1;
			}

			&__main {
				position: relative;
				height: 100%;
				min-width: 350px;
				max-width: calc(100% - 800px);

				.resize-save {
					position: absolute;
					top: 0;
					right: 5px;
					bottom: 0;
					left: 0;
					overflow-x: hidden;
				}

				.resize-bar {
					min-width: 350px;
					max-width: calc(100vw - 800px);
					height: 100%;
					resize: horizontal;
					cursor: ew-resize;
					cursor: col-resize;
					opacity: 0;
					overflow: scroll;
				}

				/* 拖拽线 */
				.resize-line {
					position: absolute;
					right: 0;
					top: 0;
					bottom: 0;
					border-right: 1px solid #d8d8d8;
					pointer-events: none;
				}

				.resize-bar:hover~.resize-line,
				.resize-bar:active~.resize-line {
					border-left: 1px dashed #337EFF;
				}

				.resize-bar::-webkit-scrollbar {
					min-width: 350px;
					height: calc(100vh - 94px);
				}
			}
		}

	}
</style>
